import { AzureLogger } from '../types/AzureTicketCreatorConfig';

/** Uniform error logging for Azure ticket-creation operations. */
export const logAzureError = (logger: AzureLogger, operation: string, error: unknown): void => {
	logger.error(`Azure ${operation} failed:`, error);
};
